/* gw-prefetch.js — Hover/Touch-Prefetch interner Links (Ersatz fuer SEOLab "Sofortseite"). Kein externes Skript. */
(function () {
  if (!('IntersectionObserver' in window) || navigator.connection && navigator.connection.saveData) return;
  var done = {};
  function prefetch(url) {
    if (done[url]) return;
    done[url] = 1;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }
  function ok(a) {
    if (!a || !a.href) return false;
    var u;
    try { u = new URL(a.href); } catch (e) { return false; }
    if (u.origin !== location.origin) return false;
    if (u.pathname === location.pathname) return false;
    if (a.hasAttribute('download') || a.target === '_blank') return false;
    if (/\/(cart|checkout|checkouts|account|orders)(\/|$)/.test(u.pathname)) return false;
    return true;
  }
  var t;
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!ok(a)) return;
    clearTimeout(t);
    t = setTimeout(function () { prefetch(a.href); }, 65);
    a.addEventListener('mouseout', function () { clearTimeout(t); }, { once: true });
  }, { passive: true });
  document.addEventListener('touchstart', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (ok(a)) prefetch(a.href);
  }, { passive: true });
})();
